export enum ConsentFrequency {
  ONCE = 'once',
  APPOINTMENT = 'appointment',
  MONTHLY = 'monthly',
  BIANNUALLY = 'biannually',
  ANNUALLY = 'annually',
}
